export enum InvoicesInsuranceListFilterKeys {
  selectedWarehouses = 'selectedWarehouses',
  creationDateFrom = 'creationDateFrom',
  creationDateTo = 'creationDateTo',
  status = 'status',
  isApplicable = 'isApplicable',
}

export enum ContractApplicabilityFilter {
  APPLICABLE = 'applicable',
  INAPPLICABLE = 'inapplicable',
}
